import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
  position: relative;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  margin: 10px 0;
  max-width: 300px;
`;

const DocumentImage = styled.img`
  width: 100%;
  height: auto;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 0;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 2rem;
  color: red;
`;

const DocumentCard = ({ imageUrl, onDelete }) => {
  return (
    <CardWrapper>
      <DocumentImage src={imageUrl} alt="Documento adjunto" />
      <DeleteButton type="button" onClick={onDelete}>
        &times;
      </DeleteButton>
    </CardWrapper>
  );
};

export default DocumentCard;
